import { useMemo } from 'react'
import { Box } from '@grupoboticario/flora-react'
import { IMagazine, PinType, IPinLinkInternal, IPinLinkExternal } from '../../../@interfaces'
import { mapPagesIndexesById, tagGA4Event } from '../../../helpers'
import { useMagazineContext, useVerticalCatalogContext } from '../../../hooks'
import { useSlider } from '../Slider'

export interface PinLinkProps {
  pin: IPinLinkInternal | IPinLinkExternal
}

export const PinLink = ({ pin }: PinLinkProps) => {
  const slider = useSlider()
  const context = useVerticalCatalogContext()
  const { pages } = useMagazineContext() as IMagazine

  const isPinInternal = pin.pinType === PinType.INTERNAL
  const pagesIndexesByIdMap = useMemo(() => mapPagesIndexesById(pages), [pages])
  const internalPageIndex = useMemo(
    () => (isPinInternal ? pagesIndexesByIdMap.get(pin.metadata.link.pageId) : undefined),
    [isPinInternal, pagesIndexesByIdMap, pin.metadata],
  )

  const isValidInternalPageIndex = internalPageIndex != null

  const pageLabel = isValidInternalPageIndex ? internalPageIndex + 1 : 'indefinida'

  const linkLabel = isPinInternal ? `Ir para página ${pageLabel}` : pin.metadata.link.description

  const handleClick = () => {
    if (isPinInternal) {
      if (!isValidInternalPageIndex) {
        return
      }

      tagGA4Event({
        event_parameters: {
          event_name: 'interaction_catalogo',
          cd_interaction_detail: `click:internal:${internalPageIndex + 1}`,
        },
      })

      if (slider) {
        slider.slideTo(internalPageIndex)
      }
      if (context) {
        context.scrollToItem(internalPageIndex + 1)
      }
      return
    }

    tagGA4Event({
      event_parameters: {
        event_name: 'interaction_catalogo',
        cd_interaction_detail: `click:external:${pin.metadata.link.url}`,
      },
    })
    window.open(pin.metadata.link.url, '_blank', 'noopener noreferrer')
  }

  return (
    <Box
      role="link"
      css={{
        cursor: 'pointer',
        position: 'absolute',
        left: `${pin.x}%`,
        top: `${pin.y}%`,
        height: `${pin.metadata.height}%`,
        width: `${pin.metadata.width}%`,
      }}
      title={linkLabel}
      className="magazine-pin-button"
      onClick={handleClick}
    />
  )
}
